import React, { Fragment } from 'react'
import { string, object, array, number, bool } from 'prop-types'
import Case from 'case'
import { FormattedMessage } from 'react-intl'
import { getImageOrDefaultSrc, urlWithTrack } from '../../../helpers/common'
import { EMPTY_ARRAY, FOLDERS, EMPTY_OBJECT } from '../../../utils/constants'
import AdLink from '../../ui/ad-link/AdLink'
// import SaveButton from '../../ui/button/SaveButton'
import Insights from '../Insights'
import { widgetMessages as messages } from '../messages'

const positions = ['a', 'b', 'c', 'd']
const imagesIndex = [0, 1, 2, 3]
export const getUserNameToShow = user => user.slug_name || user.name
export const formatUsername = user => {
  const name = getUserNameToShow(user)
  return name.indexOf('@') > 0 ? Case.pascal(name.substring(0, name.indexOf('@'))) : name.split(' ')[0]
}

const Folder = ({
  name = '',
  url = '#',
  images = EMPTY_ARRAY,
  type = FOLDERS,
  id = '',
  index = '',
  query = '',
  user = EMPTY_OBJECT,
  lastUpdate = '',
  widgetVersion
}) => {
  const trackedUrl = urlWithTrack(url, type)
  const renderImages = imagesIndex.map(index =>
    <div
      key={index}
      style={{ backgroundImage: `url(${getImageOrDefaultSrc(images[index])})` }}
      className='folder__image'
      data-object-fit='cover'
    />
  )
  const categoryType = widgetVersion ? 'search-all-widget-' : 'search-'
  const nameToShow = getUserNameToShow(user)
  // commented until backend can bookmark folders
  // const saveButtonImage = images.length > 0 ? images[0] : ''

  return (
    <Insights
      category={categoryType + type}
      label={decodeURI(query)}
      value={type + '/' + id}
      version={widgetVersion ? positions[index] : index + 1}
      className='folder__container'
    >
      {/* Images */}
      <AdLink href={trackedUrl}>
        <div className='folder__images-container'>
          {renderImages}
        </div>
      </AdLink>

      {/* Save Button */}
      {/* commented until backend can bookmark folders */}
      {/* <SaveButton title={name} image={saveButtonImage} url={url} /> */}

      <h5 className='folder__text'>
        <AdLink href={trackedUrl} className='folder__name'>
          {name}{' '}
        </AdLink>
        {!!nameToShow && (
          <Fragment>
            <FormattedMessage {...messages.by} />
            {' '}
            <AdLink href={urlWithTrack(`${user.profile_url}/folders`, type)}>
              {formatUsername(user)}
            </AdLink>
          </Fragment>
        )}
      </h5>
      {lastUpdate !== '' && query && (
        <h5 className='folder__last-update'>{<FormattedMessage {...messages.lastUpdate} />}{lastUpdate}</h5>
      )}
    </Insights>
  )
}

Folder.propTypes = {
  name: string,
  url: string,
  images: array,
  type: string,
  query: string,
  id: number,
  index: number,
  user: object,
  lastUpdate: string,
  widgetVersion: bool
}

export default Folder
